import styled, { css } from 'styled-components';

import { colors, headerSize } from '../../../../theme/styled';
import { media } from '../../../../theme/media';

export const Search = styled.div`
  position: relative;
`;

export const SearchTrigger = styled.button`
  display: block;
  background: transparent;
  border: none;
  color: inherit;
  height: ${headerSize.mobile}px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${colors.white};
  cursor: pointer;
  padding: 0 20px;

  ${media.desktopSmall`
    height: ${headerSize.desktop}px;
  `};
`;

export const SearchForm = styled.div`
  position: absolute;
  top: 100%;
  right: -145px;
  width: 240px;
  background: ${colors.darkGrey};
  padding: 20px;
  box-shadow: 0 0 28px rgba(61, 90, 113, 0.4);
  transform: translateY(20px) translateX(-50%);
  opacity: 0;
  z-index: 1;
  transition: all 0.4s ease-out;
  pointer-events: none;

  ${props =>
    props.isActive &&
    css`
      transform: translateY(-5px) translateX(-50%);
      opacity: 1;
      pointer-events: unset;
    `}

  ${media.mobile`
    right: -185px;
    width: 320px;
  `};

  &::before {
    content: '';
    position: absolute;
    top: -6px;
    right: 2.9em;
    z-index: -1;
    width: 14px;
    height: 14px;
    transform: rotate(45deg);

    background: ${colors.darkGrey};
    box-shadow: -4px -4px 4px rgba(61, 90, 113, 0.4);
  }
`;
